<script lang="ts">
	//Hooks
	import { slide } from 'svelte/transition';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Checkbox, Stack, Text } from '@Shelly/shelly-design-system/index';
	//Types
	import type { SensorScanComponent, SensorScanResult } from 'src/types/Peripherals';

	export let peripheralScanResult: SensorScanResult, selectedSensorComponent: SensorScanComponent;

	const buildPeripheralLabel = (oneWirePeripheral: SensorScanComponent): string => {
		let label = '';
		if (oneWirePeripheral.io != null) {
			label += `${$format('label_io_channel', {
				default: 'Channel',
			})} ${oneWirePeripheral.io} `;
		}
		label += `${oneWirePeripheral.type.toUpperCase()}`;
		if (oneWirePeripheral.component) {
			label +=
				' - ' +
				$format('checkbox_already_added_peripheral', {
					default: 'Already added',
				});
		}
		return label;
	};
</script>

<div style="padding-left: 36px;">
	<Stack gap="s">
		<Text class="width-full text-bold" styleType="body-small">
			{$format('text_title_peripherals', {
				default: `Peripherals:`,
			})}
		</Text>
		{#each peripheralScanResult?.peripherals as oneWirePeripheral}
			<div transition:slide={{ duration: 500 }}>
				<Checkbox
					size="m"
					id="one-wire-{oneWirePeripheral.addr}"
					checked={!oneWirePeripheral.component
						? oneWirePeripheral.addr === selectedSensorComponent?.addr
						: oneWirePeripheral.component != null}
					on:click={(e) => {
						e.preventDefault();
						selectedSensorComponent = oneWirePeripheral;
					}}
					info={oneWirePeripheral.addr}
					disabled={oneWirePeripheral.component != null}
				>
					{buildPeripheralLabel(oneWirePeripheral)}
				</Checkbox>
			</div>
		{/each}
	</Stack>
</div>
